import { useEffect, useState } from "react";
import { getEventMeta, subscribeToData } from "../services/dataService";
import type { FestivalInfo } from "../types";

export function useEventMetadata(): FestivalInfo {
  const [metadata, setMetadata] = useState<FestivalInfo>(getEventMeta);

  useEffect(() => {
    const unsubscribe = subscribeToData(() => {
      setMetadata(getEventMeta());
    });
    return () => {
      unsubscribe();
    };
  }, []);

  return metadata;
}

// Alias to match getEventMetadata hook name
export const getEventMetadata = useEventMetadata;
